import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
const Terms = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };
  return (
    <div className=" py-[3%] px-[4%] leading-loose bg-bggreen">
      <div className="flex justify-center items-center relative">
        {/* Back Arrow Icon */}
        <button
          onClick={handleGoBack}
          className="absolute left-0 p-2 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Go back"
        >
          <FaArrowLeft className="text-2xl text-gray-700" />
        </button>

        {/* Title */}
        <p className="text-[20px] md:text-[24px] lg:text-[3vw] font-poppins font-[700]">
          <strong>Terms & Conditions</strong>
        </p>
      </div>
      <p className=" ">
        <strong>TERMS OF USE</strong>
      </p>
      <p className=" text-center text-black mb-3 ">
        Livmo (referred to as &ldquo;we&rdquo;, us&rdquo;, &ldquo;Livmo
        Health&rdquo;) is the author and publisher of the internet
        resource&nbsp;http://livmohealth.com&nbsp;on the world wide web as well as
        other connected software and applications provided by Livmo Health,
        including but not limited to the mobile applications (referred to as
        &ldquo;App&rdquo;, and together with Websites referred to as
        &ldquo;Services&rdquo;). Livmo Health provides the Services in
        partnership with its agents, affiliates, associates, representatives or
        other third parties (together referred to as &ldquo;
        <strong>Partners</strong>
        &rdquo;)
      </p>
      <p className=" ">
        <strong>1. NATURE AND APPLICABILITY OF TERM</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <p className="  text-black text-left">
          Please carefully go through these terms and conditions (&ldquo;
          <strong>Terms</strong>&rdquo;) and the privacy policy available before
          you decide to access the Website or App or avail the Services made
          available by us. These Terms and the Privacy Policy together
          constitute a legal agreement (&ldquo;<strong>Agreement</strong>
          &rdquo;) between you and Livmo Health in connection with your visit to
          the Website and your use of the Services (as defined below).
        </p>
        <p className="  text-black text-left">
          <strong>The Agreement applies to you whether you are -</strong>
        </p>
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              A patient, his/her representatives/ attendant/ relative/ friend or
              affiliates (&ldquo;<strong>you</strong>&rdquo; or &ldquo;
              <strong>User</strong>&rdquo;); or
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              A user of the Website or App (&ldquo;<strong>you</strong>&rdquo;
              or &ldquo;<strong>User</strong>&rdquo;).
            </p>
          </li>
        </ol>
        <p className="  text-black text-left">
          This Agreement applies to all services made available by Livmo Health
          on the Website or App.
        </p>
        <p className="  text-black text-left">
          The Services may change from time to time, at the sole discretion of
          Livmo Health, and the Agreement will apply to your visit to and your
          use of the Website or App to avail the Service, as well as to all
          information provided by you on the Website or App at any given point
          in time.
        </p>
        <p className="  text-black text-left">
          This Agreement defines the terms and conditions under which you are
          allowed to use the Website and App and describes the manner in which
          we shall treat your account while you are registered as a member with
          us. If you have any questions about any part of the Agreement, feel
          free to contact us at&nbsp;
          <span>
            <u>
              <a href="mailto:info@livmo.in" className=" text-darkblue">
                info@livmo.in
              </a>
            </u>
          </span>
          .
        </p>
        <p className="  text-black text-left">
          By downloading or accessing the App or Website to use the Services,
          you irrevocably accept all the terms and conditions stipulated in this
          Agreement and agree to fully abide by them.
        </p>
        <p className="  text-black text-left">
          This Agreement supersedes all previous oral and written terms and
          conditions (if any) communicated to you. By availing any Service, you
          signify your agreement and acceptance to this Agreement.
        </p>
        <p className="  text-black text-left">
          We reserve the right to modify or terminate any portion of the
          Agreement for any reason and at any time.
        </p>
        <p className="  text-black text-left">
          You should read the Agreement at regular intervals. Your use of the
          App or Website following any such modification constitutes your
          agreement to follow and be bound by the Agreement so modified. Any
          additional terms and conditions, disclaimers, privacy policies and
          other policies applicable in general and/ or to specific areas of this
          Website or to particular Service are also considered as part of the
          Agreement.
          <br /> <br /> You acknowledge that you will be bound by this Agreement
          for availing any of the Services offered by us. If you do not agree
          with any part of the Agreement, please do not use the Website or avail
          any Services.
        </p>
        <p className="  text-black text-left">
          Your access to use of the Website and the Services will be solely at
          the discretion of Livmo Health. The Agreement is published in
          compliance of, and is governed by the provisions of Indian
          law,&nbsp;including but not limited to:
        </p>
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              the Indian Contract Act, 1872,
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              the (Indian) Information Technology Act, 2000, and
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              the rules, regulations, guidelines and clarifications framed there
              under, including the (Indian) Information Technology (Reasonable
              Security Practices and Procedures and Sensitive Personal
              Information) Rules, 2011 (the &ldquo;SPI Rules&rdquo;), and the
              (Indian) Information Technology (Intermediaries Guidelines) Rules,
              2011 (the &ldquo;IG Rules&rdquo;).
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>2. CONDITIONS OF USE</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <p className="  text-black text-left">
          You must be 18 years of age or older to register, use the Services, or
          visit or use the Website in any manner. By registering, visiting and
          using the Website or accepting this Agreement, you represent and
          warrant to Livmo Health that you are 18 years of age or older, and
          that you have the right, authority and capacity to use the Website and
          the Services available through the Website, and agree to and abide by
          this Agreement.
        </p>
      </div>
      <p className="  text-black text-left">
        <strong>3. END-USER ACCOUNT AND DATA PRIVACY</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              The terms &ldquo;personal information&rdquo; and &ldquo;sensitive
              personal data or information&rdquo; are defined under the SPI
              Rules, and are reproduced in the Privacy Policy.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health and its Partners may by the Services, collect
              information relating to the devices through which you access the
              Website, location from which you access and anonymous data of your
              usage. The collected information will be used only for improving
              the quality of the Services and to build new services.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              The Website and App allows Livmo Health and its Partners to have
              access to Users&rsquo; personal email or phone number, for the
              purpose of communication and analytics.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              The Privacy Policy sets out:
            </p>
            <ol className=" list-decimal pl-[3%]">
              <li>
                <p className="  text-black text-left">
                  The type of information collected from Users, including
                  sensitive personal data or information;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  The purpose, means and modes of usage of such information;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  How and to whom Livmo Health will disclose such information;
                  and,
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  Other information mandated by the SPI Rules.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p className="  text-black text-left">
              The User is expected to read and understand the Privacy Policy, so
              as to ensure that he or she has the knowledge of:
            </p>
            <ol className=" list-decimal pl-[3%]">
              <li>
                <p className="  text-black text-left">
                  the fact that certain information is being collected;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  the purpose for which the information is being collected;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  the intended recipients of the information;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  the nature of collection and retention of the information; and
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  the various rights available to such Users in respect of such
                  information.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health and its Partners shall not be responsible in any
              manner for the authenticity or correctness of the personal
              information or sensitive personal data or information supplied by
              the User to Livmo Health or to any other person acting on behalf
              of Livmo Health or its Partners.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              The User is responsible for maintaining the confidentiality of the
              User&rsquo;s account access information and password, if the User
              is registered on the Website or App. The User shall be responsible
              for all usage of the User&rsquo;s account and password, whether or
              not authorized by the User. The User shall immediately notify
              Livmo Health of any actual or suspected unauthorized use of the
              User&rsquo;s account or password. Although Livmo Health will not
              be liable for your losses caused by any unauthorized use of your
              account, you may be liable for the losses of Livmo Health or
              others due to such unauthorized use.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              If a User provides any information that is untrue, inaccurate, not
              current or incomplete (or becomes untrue, inaccurate, not current
              or incomplete), or Livmo Health has reasonable grounds to suspect
              that such information is untrue, inaccurate, not current or
              incomplete, Livmo Health has the right to discontinue the Services
              to the User at its sole discretion.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              It is your responsibility to keep your correct mobile number and
              email ID updated in the Website or App. All reminders and
              notifications will be sent to the account associated with this
              mobile number and/or email ID. Every time you change any contact
              information (mobile or email), we will send a confirmation. Livmo
              Health is not responsible for any loss or inconvenience caused due
              to your non-updation of your contact details
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health and its Partners may use such information collected
              from the Users from time to time for the purposes of debugging
              customer support related issues.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health may now or in the future provide Services where you
              may be able to converse with Livmo Health, its authorized
              representatives, its doctors or similar stakeholders via online
              chat, text messages, video call or voice call. When you choose
              this option, the records of such conversations, calls or exchanges
              may be recorded and stored in Livmo Health&rsquo;s or its Partners
              servers. Such records are dealt with only in accordance with the
              terms of the Privacy Policy. Livmo Health and its Partners accept
              no liability if you choose to use such a facility to interact with
              doctors or clinicians or if the facility is not used in accordance
              with the foregoing.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              You may be provided with a personal health record facility to add,
              modify, delete and manage your health related records and
              information. The specific terms relating to this are as below,
              without prejudice to the rest of these Terms and the Privacy
              Policy:
            </p>
            <ol className=" list-decimal pl-[3%]">
              <li>
                <p className="  text-black text-left">
                  This facility is only enabled or created for you after you
                  have signed up and explicitly accepted these Terms.
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  Information available in your Health Account is of two types:
                </p>
                <ol className=" list-decimal pl-[3%]">
                  <li>
                    <p className="  text-black text-left">
                      Patient-created: Information generated and uploaded by
                      you.
                    </p>
                  </li>
                  <li>
                    <p className="  text-black text-left">
                      Livmo Health-created: Information generated by your
                      consuming a medical&nbsp;service of Livmo Health&rsquo;s
                      partner hospital like consult, diagnostic test, admission,
                      etc.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p className="  text-black text-left">
                  Any Livmo Health-created information is provided on an as-is
                  basis and Livmo Health makes no representation in connection
                  therewith.
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  The accuracy, adequacy, reliability and liability of any
                  Patient-created information generated or created by a User is
                  the sole responsibility of the User. You fully indemnify and
                  hold harmless Livmo Health and its Partners with respect to
                  any inaccuracies, inadequacy, error, loss, problem, liability
                  or any other issue arising out of any Patient-created
                  information entered or accessed by the You or on your behalf
                  on the Website or App.
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  The personal health record facility is provided on a
                  best-efforts as-is basis. While we strive to maintain the
                  highest levels of service availability, Livmo Health or its
                  Partners are not liable for any interruption that may be
                  caused to your access of the Services.
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  Any health related reminder or notification service (like
                  medication reminder, appointment reminder, etc.) that may form
                  part of the Services is only a supplementary way of notifying
                  or reminding you of actions to take related to your health.
                  Livmo Health is not liable if for any reason a reminder or
                  notification is not delivered to you or are delivered late or
                  delivered incorrectly, despite its best efforts or if your
                  health is impacted negatively due to the same.
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  Livmo Health uses industry&ndash;level security and encryption
                  to your personal health record. However, Livmo Health cannot
                  guarantee prevention of unauthorized access if you lose your
                  login credentials or they are otherwise compromised. Please
                  safeguard your login credentials and report any actual
                  suspected breach of account to&nbsp;
                  <span>
                    <u>
                      <a
                        href="mailto:reachus@fortishealthcare.com"
                        className=" text-darkblue"
                      >
                        reachus@Livmo Healthhealthcare.com
                      </a>
                    </u>
                  </span>
                  .
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  If you access your dependents&rsquo; record through your
                  personal health record by registering your dependents with
                  your own personal health record, you are deemed to be
                  responsible for the records of your dependents and all
                  obligations that your dependent&rsquo;s would have had had
                  they maintained their own separate individual personal health
                  record.
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  If you provide anyone else access to your personal health
                  record, you are deemed to be responsible for all actions,
                  access, transaction that that person takes related to your
                  personal health record either on their own or independently.
                  Livmo Health or its Partners are not responsible or liable for
                  any action, transaction, loss, leakage or any other liability
                  arising out of this.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>4. LISTING CONTENT AND DISSEMINATING INFORMATION</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              Livmo Health collects, directly or indirectly, and displays on the
              Website, relevant information regarding the profile and practice
              of the Practitioners listed on the Website, such as their
              specialisation, qualification, fees, location, visiting hours, and
              similar details. Livmo Health takes reasonable efforts to ensure
              that such information is updated at frequent intervals. Livmo
              Health cannot be held liable for any inaccuracies or
              incompleteness represented from it, despite such reasonable
              efforts.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              The Services provided by Livmo Health or any of its licensors or
              Partners are provided on an "as is" and &ldquo;as available&rsquo;
              basis, and without any warranties or conditions (express or
              implied, including the implied warranties of merchantability,
              accuracy, fitness for a particular purpose, title and
              non-infringement, arising by statute or otherwise in law or from a
              course of dealing or usage or trade). Livmo Health and its
              Partners do not provide or make any representation, warranty or
              guarantee, express or implied about the Website, App or the
              Services. Livmo Health and its Partners do not guarantee the
              accuracy or completeness of any content or information provided by
              Users on the Website. To the fullest extent permitted by law,
              Livmo Health and its Partners disclaim all liability arising out
              of the User&rsquo;s use or reliance upon the Website, App, the
              Services, representations and warranties made by other Users, the
              content or information provided by the Users on the Website, or
              any opinion or suggestion&nbsp;given or expressed by Livmo Health
              or its Partners or any User in relation to any User or services
              provided by such User.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              The Website or App may be linked to the website of third parties,
              affiliates and business partners. Livmo Health has no control
              over, and not liable or responsible for content, accuracy,
              validity, reliability, quality of such websites or made available
              by/through our Website or App. Inclusion of any link on the
              Website or App does not imply that Livmo Health endorses the
              linked site. User may use the links and these services at
              User&rsquo;s own risk.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health and its Partners assume no responsibility, and shall
              not be liable for, any damages to, or viruses that may infect
              User&rsquo;s equipment on account of User&rsquo;s access to, use
              of, or browsing the Website or App or the downloading of any
              material, data, text, images, video content, or audio content from
              the Website or App. If a User is dissatisfied with the Website or
              App, User&rsquo;s sole remedy is to discontinue using the Website
              or App.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              If Livmo Health determines through feedback or otherwise that you
              have provided fraudulent, inaccurate, incomplete or false
              information, Livmo Health reserves the right to immediately
              suspend your access to the Website or any of your accounts with
              Livmo Health and makes such declaration about suspension on the
              website alongside your name as determined by Livmo Health for the
              protection of its business and in the interests of Users. You
              shall be liable to indemnify Livmo Health and its Partners for any
              losses incurred as a result of your misrepresentations or
              fraudulent feedback that has adversely affected Livmo Health, its
              Partners or its Users.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>
          5. BOOKING APPOINTMENTS, DIAGNOSTIC TESTS, ORDERING MEDICINES AND
          INTERACTION WITH MEDICAL SERVICE PROVIDERS
        </strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              While Livmo Health will try to ensure a confirmed appointment with
              a medical service provider (like doctor or diagnostic lab) for a
              User who requested an appointment on the Website or App, Livmo
              Health or its Partners do not guarantee that the User will get a
              confirmed appointment. Further, Livmo Health and its Partners have
              no liability if such an appointment is confirmed but later
              cancelled, postponed or rescheduled by the hospital or medical
              service provider, or the medical service provider are not
              available as per the given appointment time.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health or its Partners may provide value added services
              which connect Users directly to the medical service providers via
              video call, voice call, text message, online chat or other
              electronic means and the information exchanged between the User
              and the medical service provider is stored and used in accordance
              with the Privacy Policy. However, it is at the discretion of the
              User, to avail such Service if it is available.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              You understand and agree that any interactions and associated
              issues with other Users including but not limited to your health
              issues and your experiences is strictly between you and the other
              Users. You shall not hold Livmo Health or its Partners responsible
              for any such interactions and associated issues and Livmo Health
              will not be held responsible or liable for the same. For avoidance
              of doubt, the Services are not to provide any healthcare or
              medical advice or diagnosis and hence Livmo Health and its
              Partners are not responsible for any medical or other outcomes
              between you and the medical service providers you interact with,
              pursuant to any interactions on the Website or App. If you decide
              to engage with a medical service provider to provide medical
              services to you, you do so at your own risk. Livmo Health or its
              Partners shall not be responsible for any breach of service or
              service deficiency by any medical service provider you connect,
              engage or transact with using the Website or App. We advise you to
              perform your own investigation or get feedback prior to selecting
              a doctor or any other service provider available on the Website or
              App.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Without prejudice to the generality of the above, Livmo Health or
              its Partners will not be liable for:
            </p>
            <ol>
              <li>
                <p className="  text-black text-left">
                  any wrong medication or treatment quality being given by the
                  doctor(s), diagnostic service provider(s), pharmacy(s), or any
                  medical negligence on part of the any of the above;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  any type of inconvenience suffered by the User due to a
                  failure on the part of the medical service provider including
                  doctor to make himself/herself available at the appointed
                  time, no show by the doctor, inappropriate treatment, or
                  similar difficulties;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  cancellation or rescheduling of booked appointment or any
                  variance in the fees charged;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  any medical eventualities that might occur subsequent to using
                  the services of a doctor, diagnostic lab services, pharmacy,
                  whom the User has selected on the basis of the information
                  available on the Website or App or with whom the User has
                  booked an appointment or performed a transaction through the
                  Website or App.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p className="  text-black text-left">
              Further, Livmo Health shall not be liable, under any event, for
              any comments or feedback given by any of the Users in relation to
              the services provided by another User. All such feedback should be
              made in accordance with applicable law. The option of Users to
              give feedback remains at Livmo Health&rsquo;s sole discretion and
              may be modified or withdrawn at its sole discretion. Livmo Health
              may moderate such feedback at any time. Livmo Health shall not be
              obliged to act in any manner to give effect to the content of
              Users&rsquo; feedback.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>6. ONLINE PAYMENT ON WEBSITE AND APP</strong>
      </p>
      <div className=" mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              The Website and App provide you the ability to pay online through
              a third party payment gateway for some of the Services available
              on the Website or App.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              If you choose to pay online, you may be directed to a third party
              payment gateway to enable processing of the payment. This
              transaction will be governed by the terms and conditions and
              privacy policy of the third party payment gateway. Livmo Health
              shall not be liable (a) if any transaction does not fructify or
              may not be completed or (b) for any failure on part of the bank or
              the credit card or the third party site or agency to perform any
              of its obligations or (c) in respect of any loss or damage arising
              directly or indirectly arising out of the decline or acceptance of
              authorization for any transaction, for any reason whatsoever.
              &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
            </p>
          </li>
        </ol>
      </div>

      <p className="  text-black text-left">
        <strong>7. Cancellation and Refund Policy:</strong>
      </p>

      <div className="mb-3 mt-2 pl-[4%]">
        <p className=" text-black text-left">
          The cancellation and refund policy is only applicable to all online
          payments made through mobile app and website for booking
          appointments.&nbsp; In case cancellation is initiation by end user:
        </p>
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              Before Service Commencement- 100% of Subscription will be
              refunded. However, please note that convenience fees will not be
              refunded.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              After Service Commencement- No refund will be made for the
              remaining period
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              At the time of cancellation, amount will be refunded via same
              source of payment and will be subject to the payment terms of the
              source only. Amount will be refunded within 7 working days.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>8. CONTENT OWNERSHIP AND COPYRIGHT CONDITIONS OF ACCESS</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              The contents listed on the Website are
            </p>
            <ol>
              <li>
                <p className="  text-black text-left">
                  User generated content, or
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  Belong to Livmo Health and its Partners.
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  The information that is collected by Livmo Health directly or
                  indirectly from the Users shall belong to Livmo Health and its
                  Partners. Copying of the copyrighted content published by
                  Livmo Health or its Partners on the Website for any commercial
                  purpose or for the purpose of earning profit will be a
                  violation of copyright and Livmo Health and its Partners
                  reserve their rights to take action under applicable law
                  accordingly.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health authorizes the User to view and access the content
              available on or from the Website solely for ordering, receiving,
              delivering, sharing, storing and communicating only as per this
              Agreement. The contents of the Website, App, information, text,
              graphics, images, logos, button icons, software code, design, and
              the collection, arrangement and assembly of content on the Website
              (collectively, "Livmo Health Content"), are the property of Livmo
              Health or its Partners and are protected under copyright,
              trademark and other applicable laws. User shall not modify the
              Livmo Health Content or reproduce, display, publicly perform,
              distribute, or otherwise use the Livmo Health Content in any way
              for any public or commercial purpose or for personal gain.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              User shall not access the Services for purposes of monitoring
              their availability, performance or functionality, or for any other
              benchmarking or competitive purposes.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>9. REVIEWS AND FEEDBACK</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <p className="  text-black text-left">
          By using this Website, you agree that any information shared by you
          with Livmo Health or with any other person, medical service provider
          or anyone else using the Website, App or Services will be subject to
          our Privacy Policy.
        </p>
        <p className="  text-black text-left">
          You are solely responsible for the content that you choose to submit
          for publication on the Website, including any feedback, ratings, or
          reviews (&ldquo;Critical Content&rdquo;). The role of Livmo Health in
          publishing Critical Content is restricted to that of an
          &lsquo;intermediary&rsquo; under the Information Technology Act, 2000.
          Livmo Health disclaims all responsibility with respect to the content
          of Critical Content, and its role with respect to such content is
          restricted to its obligations as an &lsquo;intermediary&rsquo; under
          the said Act. Livmo Health shall not be liable to pay any
          consideration to any User for re-publishing any content across any of
          its or its Partners platforms.&nbsp;
        </p>
        <p className="  text-black text-left">
          Your publication of reviews and feedback on the Website is governed by
          Clause 10 stated hereinafter.&nbsp;Without prejudice to the detailed
          terms stated in Clause 10, you hereby agree not to post or publish any
          content on the Website that (a) infringes any third-party intellectual
          property or publicity or privacy rights, or (b) violates any
          applicable law or regulation, including but not limited to the IG
          Rules and SPI Rules. Livmo Health, at its sole discretion, may choose
          not to publish your reviews and feedback, if so required by applicable
          law, and in accordance with Clause 5 of these Terms. You agree that
          Livmo Health may contact you through telephone, email, SMS, or any
          other electronic means of communication for the purpose of:
        </p>
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              Obtaining feedback in relation to Website, App or Livmo
              Health&rsquo;s services; and/or
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Obtaining feedback in relation to any medical service providers on
              the Website or App; and/or
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Resolving any complaints, information, or queries by medical
              service providers regarding your Critical Content;
            </p>
          </li>
        </ol>
        <p className="  text-black text-left">
          and you agree to provide your fullest co-operation further to such
          communication by Livmo Health.
        </p>
      </div>
      <p className="  text-black text-left">
        <strong>10. RIGHTS AND OBLIGATIONS RELATING TO CONTENT</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              As mandated by Regulation 3(2) of the IG Rules, Livmo Health
              hereby informs Users that they are not permitted to host, display,
              upload, modify, publish, transmit, update or share any information
              that:
            </p>
            <ol className=" list-decimal pl-[3%]">
              <li>
                <p className="  text-black text-left">
                  belongs to another person and to which the User does not have
                  any right to;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  is grossly harmful, harassing, blasphemous, defamatory,
                  obscene, pornographic, pedophilic, libelous, invasive of
                  another's privacy, hateful, or racially, ethnically
                  objectionable, disparaging, relating or encouraging money
                  laundering or gambling, or otherwise unlawful in any manner
                  whatever;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  harm minors in any way;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  infringes any patent, trademark, copyright or other
                  proprietary rights;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  violates any law for the time being in force;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  deceives or misleads the addressee about the origin of such
                  messages or communicates any information which is grossly
                  offensive or menacing in nature;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  impersonate another person;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  contains software viruses or any other computer code, files or
                  programs designed to interrupt, destroy or limit the
                  functionality of any computer resource;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  threatens the unity, integrity, defence, security or
                  sovereignty of India, friendly relations with foreign states,
                  or public order or causes incitement to the commission of any
                  cognisable offence or prevents investigation of any offence or
                  is insulting any other nation.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p className="  text-black text-left">
              Users are also prohibited from:
            </p>
            <ol className=" list-decimal pl-[3%]">
              <li>
                <p className="  text-black text-left">
                  violating or attempting to violate the integrity or security
                  of the Website, App or any Livmo Health Content;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  transmitting any information (including job posts, messages
                  and hyperlinks) on or through the Website or App that is
                  disruptive or competitive or prejudicial to the provision of
                  Services by Livmo Health;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  intentionally submitting any incomplete, false or inaccurate
                  information;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  making any unsolicited communications to other Users;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  using any engine, software, tool, agent or other device or
                  mechanism (such as spiders, robots, avatars or intelligent
                  agents) to navigate or search the Website;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  attempting to decipher, decompile, disassemble or reverse
                  engineer any part of the Website or App;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  copying or duplicating in any manner any of the Livmo Health
                  Content or other information available from the Website or
                  App;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  framing or hot linking or deep linking any Livmo Health
                  Content.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health or its Partners, upon obtaining knowledge by itself
              or been brought to actual knowledge by an affected person in
              writing or through email signed with electronic signature about
              any such information (as mentioned above) generated by Users, or
              on being notified by the appropriate Government or its agency that
              the Website or App is being used by the User to commit any
              unlawful act and/or is being used in violation of Clauses 10.a and
              10.b above, shall be entitled to remove or disable access to the
              material or information that is in contravention of Clause 10.
              Livmo Health is entitled to act, as required by the IG Rules,
              within thirty six hours of obtaining such knowledge and, where
              applicable, work with Users to disable such information that is in
              contravention of applicable law. Livmo Health shall also be
              entitled to preserve such information and associated records for
              at least 90 (ninety) days for production to governmental
              authorities for investigation purposes.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              In case of non-compliance with any applicable laws, rules or
              regulations, or the Agreement (including the Privacy Policy) by a
              User, Livmo Health has the right to immediately terminate the
              access or usage rights of the User to the Website, App and
              Services and to remove non-compliant information from the Website.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Livmo Health may disclose or transfer User-generated information
              to its affiliates or governmental authorities in such manner as
              permitted or required by applicable law, and you hereby consent to
              such transfer. Livmo Health will comply with any duly-issued
              government or court directions to disable access to the
              User-generated information, should it be found to be illegal by a
              competent governmental authority.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>11. INTELLECTUAL PROPERTY RIGHTS</strong>
      </p>
      <div className=" mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              The contents of the Website and App are protected by intellectual
              property laws of India including without limitation to trademark
              and copyright laws. Reproduction, retransmission, public and/or
              commercial use of any or all the material on the Website and App
              are prohibited. The logos, service marks and trademarks ("
              <strong>IP Marks</strong>") displayed on the Website or App are
              the property of Livmo Health or its Partners or have been licensed
              to Livmo Health or its Partners by the relevant owners for use.
              The User may use this material only as expressly authorized by
              Livmo Health or its Partners and shall not copy, transmit or
              create derivative works of such material without express
              authorization from Livmo Health or its Partners.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              The User acknowledges and agrees that they shall not upload, post,
              reproduce or distribute any content on or through the Website or
              App that is protected by copyright or other proprietary right of a
              third party, without obtaining the permission of the owner of such
              right. Any copyrighted or other proprietary content distributed on
              or through the Website or App with the consent of the owner must
              contain the appropriate copyright or other proprietary rights
              notice. The unauthorized submission or distribution of copyrighted
              or other proprietary content is illegal and could subject the User
              to personal liability or criminal&nbsp;prosecution. Nothing on the
              Website or App should be construed as granting, by implication,
              estoppels, or otherwise, any license or right to use any
              trademarks without written permission from Livmo Health.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>12. TERMINATION</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              Livmo Health reserves the right to suspend or terminate a
              User&rsquo;s access to the Website and the Services with or
              without notice and to exercise any other remedy available under
              law where:
            </p>
            <ol className=" list-decimal pl-[3%]">
              <li>
                <p className="  text-black text-left">
                  Such User breaches any terms and conditions of the Agreement;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  A third party reports violation of any of its right as a
                  result of your use of the Services;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  Livmo Health is unable to verify or authenticate any
                  information provide to Livmo Health by a User;
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  Livmo Health has reasonable grounds for suspecting any
                  illegal, fraudulent or abusive activity on part of such User;
                  or
                </p>
              </li>
              <li>
                <p className="  text-black text-left">
                  Livmo Health believes in its sole discretion that User&rsquo;s
                  actions may cause legal liability for such User, other Users
                  or for Livmo Health or its Partners or are contrary to the
                  interests of the Website.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p className="  text-black text-left">
              Once temporarily suspended, indefinitely suspended or terminated,
              the User may not continue to use the Website under the same
              account, a different account or re-register under a new account.
              On termination of an account due to the reasons mentioned herein,
              such User shall no longer have access to data, messages, files and
              other material kept on the Website by such User. The User shall
              ensure that he/she/it has continuous backup of any medical
              services the User has rendered in order to comply with the
              User&rsquo;s record keeping process and practices.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>13. DISCLAIMER OF WARRANTIES</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              All information available on the Website or App, (the &ldquo;
              <strong>Information</strong>&rdquo;) is provided on the condition
              that the User will make independent determination in respect of
              its accuracy, completeness or usefulness suitability prior to use
              or making any decision for any loss or damage in reliance hereof.
              Livmo Health and its Partners will not be responsible for the
              same. Further Livmo Health and its Partners will not be
              responsible or liable in any manner for any data added, provided,
              stored or managed by the User including all personally
              identifiable information
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              The Information does not constitute an invitation or
              recommendation to take medical services from Livmo Health or its
              Partners nor is such Information a substitute for professional
              advice or solicitation in respect of medical services/ products or
              recommendation thereof. Livmo Health urges the Users to seek the
              advice of professionals, as appropriate, regarding the evaluation
              of any specific opinion, advice, product, service, or other
              Information.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              All information on the Website is provided to you "as is" without
              warranty of any kind either express or implied including, but not
              limited to implied warranties of merchantability and fitness for a
              particular purpose, title, non-infringement, security or accuracy.
              In no event shall Livmo Health or its Partners be liable for any
              special, direct, indirect or consequential damages or any damages
              whatsoever resulting from loss, whether in an action of contract,
              negligence or other tortuous action, arising out of or in
              connection with the use or performance of information. All
              information available on a hyper-link site and any third party is
              subject to the terms and conditions of the legal notices contained
              therein.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>14. LIMITATION OF LIABILITY</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%] ">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              The information available on the Website or App could include
              inaccuracies or typographic errors. Livmo Health has endeavored to
              ensure that all the information on the Website is correct, but
              Livmo Health neither warrants nor makes any representations
              regarding the quality, accuracy or completeness of any data or
              information contained. Livmo Health makes no warranty, express or
              implied, concerning the website or App and/or its contents and
              disclaims all warranties of fitness for a particular purpose and
              warranties of merchantability in respect of Services, including
              any liability, responsibility or any other claim, whatsoever, in
              respect of any loss, whether direct or consequential, to any user
              or any other person, arising out of or from the use of the
              information contained in the website.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              In no event shall Livmo Health or its Partners be liable for any
              direct, indirect, punitive, incidental, special, consequential
              damages or any other damages resulting from: (a) the use or the
              inability to use the Services; (b) unauthorized access to or
              alteration of the User's transmissions or data; (c) any other
              matter relating to the services; including, without limitation,
              damages for loss of use, data or profits, arising out of or in any
              way connected with the use or performance of the website. Neither
              shall the Company be responsible for the delay or inability to use
              the Website, App, Services or any related services, the provision
              of or failure to provide services, or for any information,
              software, products, services and related graphics obtained through
              the Website or App, or otherwise arising out of the use of the
              Website or App, whether based on contract, tort, negligence,
              strict liability or otherwise. Further, Livmo Health shall not be
              held responsible for non-availability or access to the Website or
              App during periodic maintenance operations or any unplanned
              suspension of access to the Website that may occur due to
              technical reasons or for any reason beyond Livmo Health control.
              The user understands and agrees that any material and/or data
              downloaded or otherwise obtained through the website is done
              entirely at his/her own discretion and risk and the User
              himself/herself will be solely responsible for any damage to their
              computer systems or loss of data that results from the download of
              such material and/or data. These limitations, disclaimer of
              warranties and exclusions apply without regard to whether the
              damages arise&nbsp;from (a) breach of contract, (b) breach of
              warranty, (c) negligence, or (d) any other cause of action, to the
              extent such exclusion and limitations are not prohibited by
              applicable law.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>15. INDEMNITY</strong>
      </p>
      <div className=" mb-3 mt-2 pl-[4%]">
        <p className="  text-black text-left">
          User agrees to indemnify and hold harmless Livmo Health, its
          affiliates, officers, directors, employees, consultants, licensors,
          agents, representatives and Partners from any and all third party
          claims, losses, liability, damages, and/or costs (including reasonable
          attorney fees and costs) arising from User&rsquo;s access to or use of
          Service, violation of this Agreement, or infringement, or infringement
          by any other User of his/her/its account, of any intellectual property
          or other right of any person or entity. Livmo Health will notify you
          promptly of any such claim, loss, liability, or demand, and in
          addition to your foregoing obligations, you agree to provide us with
          reasonable assistance, at your expense, in defending any such claim,
          loss, liability, damage, or cost.
        </p>
      </div>
      <p className="  text-black text-left">
        <strong>16. APPLICABLE LAW AND DISPUTE SETTLEMENT</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              You agree that this Agreement and any contractual obligation
              between the Company and User will be governed by the laws of
              India.
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              Subject to the above Paragraph above, the courts at Delhi shall
              have exclusive jurisdiction over any disputes arising out of or in
              relation to this Agreement, your use of the Website or the
              Services or the information to which it gives access.
            </p>
          </li>
        </ol>
      </div>
      <p className="  text-black text-left">
        <strong>17. CONTACT INFORMATION GRIEVANCE OFFICER</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <ol className=" list-decimal pl-[3%]">
          <li>
            <p className="  text-black text-left">
              If a User has any questions concerning the Company, the Website or
              App, this Agreement, the Services, or anything related to any of
              the foregoing, please write to us at&nbsp;
              <span>
                <u>
                  <a href="mailto:info@livmo.in" className=" text-darkblue">
                    info@livmo.in
                  </a>
                </u>
              </span>
              .
            </p>
          </li>
          <li>
            <p className="  text-black text-left">
              In accordance with the Information Technology Act, 2000, and the
              rules made there under, if you have any grievance with respect to
              the Website or App or the Service, including any discrepancies and
              grievances with respect to processing of information, you can
              contact our Grievance Officer at:
            </p>
          </li>
        </ol>
        <p className="  text-black text-left">
          In the event you suffer as a result of access or usage of our Website
          by any person in violation of Rule 3 of the IG Rules, please address
          your grievance to the above person.
        </p>
      </div>
      <p className="  text-black text-left">
        <strong>18. SEVERABILITY</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <p className="  text-black text-left">
          If any provision of the Agreement is held by a court of competent
          jurisdiction or arbitral tribunal to be unenforceable under applicable
          law, then such provision shall be excluded from this Agreement and the
          remainder of the Agreement shall be interpreted as if such provision
          were so excluded and shall be enforceable in accordance with its
          terms; provided however that, in such event, the Agreement shall be
          interpreted so as to give effect, to the greatest extent consistent
          with and permitted by applicable law, to the meaning and intention of
          the excluded provision as determined by such court of competent
          jurisdiction or arbitral tribunal.
        </p>
      </div>
      <p className="  text-black text-left">
        <strong>19. WAIVER</strong>
      </p>
      <div className="mb-3 mt-2 pl-[4%]">
        <p className="  text-black text-left">
          No provision of this Agreement shall be deemed to be waived and no
          breach excused, unless such waiver or consent shall be in writing and
          signed by Livmo Health. Any consent by Livmo Health to, or a waiver by
          Livmo Health of any breach by you, whether expressed or implied, shall
          not constitute consent to, waiver of, or excuse for any other
          different or subsequent breach.
        </p>
      </div>
      <div className=" flex justify-center mt-[5%]">
        <button
          className="border-[2px] border-primary py-2 px-5 rounded-xl group bg-primary hover:bg-black hover:border-black "
          onClick={() => {
            navigate(-1);
          }}
        >
          <p className="text-black font-[600] group-hover:text-white">
            Go Home
          </p>
        </button>
      </div>
    </div>
  );
};

export default Terms;
